import clsx from "clsx";
import memoize from "fast-memoize";
import { Form, Formik } from "formik";
import { useState, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useStyles } from "../../../shared/styles/useStyles";
import { Autocomplete } from "@material-ui/lab";
import { IUserCorrespondence } from "../../../interfaces/Correspondence";
import { IUserForm } from "../../../module/admin/form/IUsersForm";
import { SendCopyTable } from "./SendCopyTable";
import { startsendCorrespondenceCopy } from "../../../redux/actions/documentManagmentActions";
import { ISendCopy, ISendCopyExpedient } from "../../../redux/types/types";
import { firebase } from "../../../config/firebase/firebase-config";
import { startsendExpedientCopy } from "../../../redux/actions/centralArchiveActions";
import { TypeArchive } from "../../../enums/enums";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  uiCloseErrorAlert,
  uiCloseModalAction,
} from "../../../redux/actions/uiActions";
import { MyAlert } from "../../custom/MyAlert";

interface Props {
  fromModule?: TypeArchive;
  filesModule?: boolean;
}
export const SendCopyForm = ({ fromModule, filesModule = false }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [alreadyCopy, setAlreadyCopy] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const { errorAlert, errorMsg, successAlert, successMsg } = useSelector(
    (state: AppState) => state.ui
  );


  const { activeCorrespondence: CorrespondenceModule } = useSelector(
    (state: AppState) => state.documentManagment
  );
  // EXPEDIENTE ACTIVO PARA FILES MODULE
  const { activeExpedient: FuidDocumentManagement } = useSelector(
    (state: AppState) => state.fuid
  );
  const { activeExpedientFileModule: FuidFilesModule } = useSelector(
    (state: AppState) => state.fileModule
  );
  const expedient = fromModule ? FuidFilesModule : FuidDocumentManagement;

  const expedientDocumentModule = CorrespondenceModule
    ? CorrespondenceModule
    : FuidDocumentManagement
    ? FuidDocumentManagement
    : FuidFilesModule;

  const { latestProductionOffices } = useSelector((state: AppState) => state.trd);
  const { users } = useSelector((state: AppState) => state.users);
  const [addresseeSelected, setAddresseeSelected] =
    useState<IUserCorrespondence | null>(null);
  const [errorAddressee, setErrorAddressee] = useState(false);
  const [checked, setChecked] = useState(false);

  const initialValues = {
    receivingDependency: "",
    addressee: { id: "", name: "" },
  };

  const validationSchema = yup.object({
    receivingDependency: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    //addressee: yup.object().required(`${intl.formatMessage({ id: "RequiredFile" })}`),
  });

  const onClose = () => {
    dispatch(uiCloseModalAction());
  };

  const handleSelectAddressees = (value: any) => {
    !value ? setErrorAddressee(true) : setErrorAddressee(false);

    value ? setAddresseeSelected(value) : setAddresseeSelected(null);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getUsers = useCallback(
    memoize((dependency: string) => {
      const filteredUsers: IUserForm[] = (users as IUserForm[]).filter((el) =>
        el.offices.toString().includes(dependency)
      );
      const arrayUsers: IUserCorrespondence[] = [];

      filteredUsers.forEach((user: IUserForm) => {
        arrayUsers.push({
          id: user.id.toString(),
          name:
            user.firstName +
            " " +
            user.secondName +
            " " +
            user.firstLastName +
            " " +
            user.secondLastName,
        });
      });

      return arrayUsers;
    }),
    []
  );
  const handleChangeDependency = (value: string, setValue: Function) => {
    setValue("receivingDependency", value);
    setAddresseeSelected(null);
    setErrorAddressee(true);
  };
  const handleChangeCheck = () => {
    setChecked(!checked);
  };

  return (
    <Box m={2} mt={-1} mb={2}>
      <Formik
        validateOnChange={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          setSubmitting(true);

          if (!errorAddressee) {
            values.addressee = addresseeSelected as IUserCorrespondence;
            // TODO: Disparar acción

            if (expedientDocumentModule) {
              const lastCopySender = expedientDocumentModule.copyTo;
              const lastCopySenderIds = expedientDocumentModule.copyToIds;
              const finalUsers = lastCopySender
                ? [
                    ...lastCopySender,
                    {
                      id: values.addressee.id,
                      submitDate: firebase.firestore.Timestamp.now(),
                      userName: values.addressee.name,
                      uploadPermission: checked,
                    },
                  ]
                : [
                    {
                      id: values.addressee.id,
                      submitDate: firebase.firestore.Timestamp.now(),
                      userName: values.addressee.name,
                      uploadPermission: checked,
                    },
                  ];

              const objsSendCopy: ISendCopy = {
                idCorrespondence: expedientDocumentModule.id,
                users: finalUsers,
              };

              const objsSendCopyExpedient: ISendCopyExpedient = {
                idExpedient: expedientDocumentModule.id,
                users: finalUsers,
              };

              if (lastCopySenderIds) {
                if (lastCopySenderIds.includes(values.addressee.id)) {
                  setAlreadyCopy(true);
                } else {
                  setAlreadyCopy(false);
                  if (!CorrespondenceModule) {
                    await dispatch(
                      startsendExpedientCopy(
                        objsSendCopyExpedient,
                        values.addressee,
                        fromModule ? true : false
                      )
                    );
                  } else {
                    await dispatch(
                      startsendCorrespondenceCopy(
                        objsSendCopy,
                        values.addressee
                      )
                    );
                  }
                }
              } else {
                if (!CorrespondenceModule) {
                  await dispatch(
                    startsendExpedientCopy(
                      objsSendCopyExpedient,
                      values.addressee,
                      fromModule ? true : false
                    )
                  );
                } else {
                  await dispatch(
                    startsendCorrespondenceCopy(objsSendCopy, values.addressee)
                  );
                }
              }
            }
          }

          setSubmitting(false);
        }}
      >
        {({ values, setFieldValue }) => (
          <Form className={classes.input}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <label className="form-text">
                  <FormattedMessage id="SelectDependency" />:
                </label>
                <TextField
                  name="receivingDependency"
                  variant="outlined"
                  size="small"
                  select
                  value={values.receivingDependency}
                  className={classes.myTextFieldRoot}
                  onChange={(e) =>
                    handleChangeDependency(e.target.value as any, setFieldValue)
                  }
                >
                  {latestProductionOffices.map((productionOffice) => (
                    <MenuItem
                      key={productionOffice.idProductionOffice}
                      value={productionOffice.idProductionOffice}
                    >
                      {productionOffice.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <label className="form-text">
                  <FormattedMessage id="SelectOfficerSendCopy" />:
                </label>
                <Autocomplete
                  id="addressee"
                  value={addresseeSelected}
                  options={getUsers(values.receivingDependency)}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.name}
                  getOptionSelected={(option, value) => option.id === value.id}
                  renderOption={(option) => <>{option.name}</>}
                  onChange={(event: any, value: IUserCorrespondence | null) =>
                    handleSelectAddressees(value)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      name="addressee"
                      className={classes.myTextFieldRoot}
                      helperText={
                        errorAddressee &&
                        `${intl.formatMessage({ id: "RequiredFile" })}`
                      }
                      error={errorAddressee}
                      FormHelperTextProps={{
                        className: classes.helperText,
                      }}
                    />
                  )}
                />
              </Grid>
              {alreadyCopy && (
                <Grid item xs={12}>
                  <Box mt={-2} ml={2} style={{ fontSize: 12, color: "red" }}>
                    <FormattedMessage id="AlreadySendCopy" />
                  </Box>
                </Grid>
              )}

              <Box mt={2} display="flex" flexDirection="row-reverse" width={1}>
                {!isSubmitting ? (
                  <Button
                    className={clsx(classes.btn, classes.save)}
                    autoFocus
                    type="submit"
                    disabled={isSubmitting}
                  >
                    <FormattedMessage id="SendCopy" />
                  </Button>
                ) : (
                  <Button
                    className={clsx(classes.btn, classes.save)}
                    autoFocus
                    type="button"
                    disabled={true}
                  >
                    <CircularProgress className={classes.btnLoading} />
                  </Button>
                )}
                {!CorrespondenceModule && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleChangeCheck}
                        color="primary"
                      />
                    }
                    label={intl.formatMessage({ id: "UploadPermission" })}
                  />
                )}
              </Box>

              <SendCopyTable
                copySended={
                  expedient
                    ? expedient.copyTo
                      ? expedient.copyTo
                      : []
                    : CorrespondenceModule && CorrespondenceModule.copyTo
                    ? CorrespondenceModule.copyTo
                    : []
                }
                readOnly={fromModule ? true : false}
              />
              <Box mt={2} display="flex" flexDirection="row-reverse" width={1}>
                <Button
                  className={clsx(classes.btn, classes.cancel)}
                  onClick={onClose}
                >
                  <FormattedMessage id="Cancel" />
                </Button>
              </Box>
            </Grid>
          </Form>
        )}
      </Formik>
      {successMsg && (
        <MyAlert
          open={successAlert}
          typeAlert="error"
          message={successMsg}
          time={2000}
          handleClose={() => dispatch(uiCloseErrorAlert())}
        />
      )}

      {errorMsg && (
        <MyAlert
          open={errorAlert}
          typeAlert="error"
          message={errorMsg}
          time={2000}
          handleClose={() => dispatch(uiCloseErrorAlert())}
        />
      )}
    </Box>
  );
};
